export const ROUTES = {
    HOME: '/',
    // POPS 1.0 routes
    LICENSOR: {
        INDEX: '/licensor',
        CREATE: '/create-new-model'
    },
    MSS_INPUT: '/mss-input',
    PLAN_MAPPINGS: {
        INDEX: '/plan-mappings',
        CREATE: '/create-new-plan-mapping',
        EDIT_LICENSORS: '/edit-licensor-info'
    },
    ROYALTY_PLANS: '/royalty-plans',
    BASE_PLANS: '/base-plans',
    ROYALTY_PLAN_MAPPINGS: 'royalty-plan-mappings',
    ADD_ON_PLANS: '/add-on-plans',
    // POPS 2.0 routes
    LABELS: '/labels',
    REPORTING: {
        INDEX: '/reporting'
    },
    DEALS: {
        INDEX: '/deals',
        ADD: '/add'
    },
    VENDORS: {
        INDEX: '/vendors',
        ADD: '/add',
        EDIT: '/edit'
    },
    // TODO: will deprecate RATE_CARDS_V1 after Add rate card v2 wolkflow is complete
    RATE_CARDS_V1: {
        INDEX: '/rate-cards',
        ADD: '/add-v1',
        EDIT: '/edit-v1',
        VIEW: '/view-v1'
    },
    RATE_CARDS: {
        INDEX: '/rate-cards',
        ADD: '/add',
        EDIT: '/edit',
        STEP: {
            CORE_RATES: '/core-rates',
            CONTRACT_TERMS: '/contract-terms',
            FIRST_PARTY_DISCOUNTED_RATES: '/1p-discounted-rates',
            THIRD_PARTY_DISCOUNTED_RATES: '/3p-discounted-rates',
            REVIEW: '/review'
        }
    },
    PAPER_PLANS: {
        INDEX: '/paper-plans',
        ADD: '/add',
        EDIT: '/edit',
        STEP: {
            SETTINGS: '/settings',
            DETAILS: '/details',
            WEIGHTS: '/weights',
            REVIEW: '/review'
        }
    },
    SERVICE_LAUNCHES: {
        INDEX: '/launch-dates',
        EDIT: '/edit',
        ADD: '/add',
        STEP: {
            INPUT: '/input',
            REVIEW: '/review'
        }
    },
    CURRENCY_CONTENT_ACQUISITION_ENTITY: {
        INDEX: '/currency-content-acquisition-entity'
    },
    PLAN_WEIGHTS: {
        INDEX: '/plan-weights'
    },
    PAPER_PLAN_MAPPINGS: {
        INDEX: '/paper-plan-mappings',
        ADD: '/add',
        EDIT: '/edit',
        STEP: {
            DETAILS: '/details',
            REVIEW: '/review'
        }
    },
    BASE_PLAN_LAUNCH_DATES: {
        INDEX: '/base-plan-launch-dates',
        ADD: '/add',
        EDIT: '/edit',
        STEP: {
            DETAILS: '/details',
            REVIEW: '/review'
        }
    },
    REVIEW_PAPER_PLANS: {
        INDEX: '/review-paper-plans'
    },
    BUNDLE_PRICING: {
        INDEX: '/bundle-pricing',
        EDIT: '/edit',
        STEP: {
            BUNDLE_PRICING: '/bundle-pricing',
            REVIEW: '/review'
        }
    },
    RELEASE_NOTES: {
        INDEX: '/release-notes'
    },
    COMPARE: {
        INDEX: '/compare',
        CONTRACTS: '/compare/contracts',
        DEALS: '/compare/deals'
    },
    ANALYTICS: {
        INDEX: '/analytics',
        LICENSING_KPI: {
            INDEX: '/analytics/licensing-kpi',
            AMU_METRICS: '/analytics/licensing-kpi/amu-metrics',
            PRIME_METRICS: '/analytics/licensing-kpi/prime-metrics',
            AMF_METRICS: '/analytics/licensing-kpi/amf-metrics'
        },
        MONTH_OVER_MONTH_PAYMENTS: '/month-over-month-payments'
    },
    AI: {
        INDEX: '/ai'
    },
    SETTINGS: {
        INDEX: '/settings',
        AI: '/settings/ai'
    },
    ROYALTY_MANAGER: {
        INDEX: '/royalty-manager'
    },
    AGREEMENTS: {
        INDEX: '/agreements'
    }
} as const;

export const URL_PARAMS = {
    VENDOR_ID: '/:vendorId',
    PAPER_PLAN_MAPPING_ID: '/:paperPlanMappingId',
    RATE_CARD_ID: '/:rateCardId',
    PAPER_PLAN_ID: '/:paperPlanId',
    BASE_PLAN_LAUNCH_DATE_ID: '/:basePlanLaunchDateId',
    EDIT_TYPE: '/:editType',
    CONVERSATION_ID: '/:conversationId',
    EXECUTION_REQUEST_ID: '/:executionRequestId'
} as const;

export const HOME_ROUTE_SET: Set<string> = new Set([ROUTES.HOME]);

export const LABELS_ROUTE_SET: Set<string> = new Set([
    ROUTES.DEALS.INDEX,
    ROUTES.VENDORS.INDEX,
    ROUTES.RATE_CARDS.INDEX,
    ROUTES.REPORTING.INDEX,
    ROUTES.AGREEMENTS.INDEX
]);

export const RESOURCES_ROUTE_SET: Set<string> = new Set([
    ROUTES.PAPER_PLANS.INDEX,
    ROUTES.SERVICE_LAUNCHES.INDEX,
    ROUTES.CURRENCY_CONTENT_ACQUISITION_ENTITY.INDEX,
    ROUTES.PAPER_PLAN_MAPPINGS.INDEX,
    ROUTES.BASE_PLAN_LAUNCH_DATES.INDEX,
    ROUTES.PLAN_WEIGHTS.INDEX,
    ROUTES.BUNDLE_PRICING.INDEX,
    ROUTES.REVIEW_PAPER_PLANS.INDEX,
    ROUTES.COMPARE.INDEX
]);

export const ROYALTY_MANAGER_ROUTE_SET: Set<string> = new Set([ROUTES.ROYALTY_MANAGER.INDEX]);

export const ANALYTICS_ROUTE_SET: Set<string> = new Set([
    ROUTES.ANALYTICS.INDEX,
    ROUTES.ANALYTICS.LICENSING_KPI.INDEX,
    ROUTES.ANALYTICS.LICENSING_KPI.AMU_METRICS,
    ROUTES.ANALYTICS.LICENSING_KPI.PRIME_METRICS,
    ROUTES.ANALYTICS.LICENSING_KPI.AMF_METRICS,
    ROUTES.ANALYTICS.MONTH_OVER_MONTH_PAYMENTS
]);

export const AI_ROUTE_SET: Set<string> = new Set([ROUTES.AI.INDEX]);

export const SETTINGS_ROUTE_BASE: Set<string> = new Set([ROUTES.SETTINGS.INDEX]);

// Automatically extract all valid base paths from ROUTES
const getAllValidBasePaths = (): Set<string> => {
    const paths = new Set<string>();
    const extractPaths = (obj: any) => {
        Object.values(obj).forEach((value) => {
            if (typeof value === 'string' && value.startsWith('/')) {
                paths.add(`/${value.split('/')[1]}`);
            } else if (typeof value === 'object' && value !== null) {
                extractPaths(value);
            }
        });
    };
    extractPaths(ROUTES);
    return paths;
};

export const ALL_VALID_BASE_PATHS = getAllValidBasePaths();
